module.exports = __webpack_public_path__ + "assets/images/opener-imagec63176b3.jpg";